<template>
    <div id="main-wrapper" :class="layout">
        <div id="app">
            <component :is="layout">
                <router-view />
                <notifications />
            </component>
        </div>
    </div>
</template>

<script>
import Default from '@/views/layout/Default';
import Mobile from '@/views/layout/Mobile';
import Start from '@/views/layout/Start';
import Notifications from '@/components/Notifications';

let defaultLayout = 'default';
export default {
    data: function() {
        return {
            interval: 60000
        };
    },
    components: {
        Default,
        Mobile,
        Start,
        Notifications
    },
    computed: {
        layout() {
            if (document.documentElement.clientWidth < this.$root.desktopWidth) {
                defaultLayout = 'mobile';
            }
            if (Object.prototype.hasOwnProperty.call(this.cookie, 'isMobile') && JSON.parse(this.cookie.isMobile) === false) {
                defaultLayout = 'default';
            }
            return this.$route.meta.layout || defaultLayout;
        },
        cookie() {
            return document.cookie.split('; ').reduce((prev, current) => {
                const [name, value] = current.split('=');
                prev[name] = value;
                return prev;
            }, {});
        }
    },
    created() {
        this.getMetrics();
    },
    methods: {
        getMetrics() {
            if (this.$store.getters.isAuthenticated) {
                this.$store.dispatch('metrics/getMetrics');
            }
        }
    }
};
</script>
